module.exports = __webpack_public_path__ + "img/exercise.20502db8.png";